<template>
    <div class="testimonial-area-1 section-gap-equal bg-lighten04">
        <div class="container">
            <div class="row g-lg-12">
                <div class="col-lg-12">
                    <div class="testimonial-heading-area">
                        <div class="section-title section-left" data-aos-delay="50" data-aos="fade-up" data-aos-duration="800">
                            <span class="pre-title">香港基督徒中樂團</span>
                            <h2 class="title">以中國器樂讚美上帝及服侍教會</h2> <!--樂團相簿-->
                            <span class="shape-line"><i class="icon-19"></i></span>
                            <br><br>
                            <vueper-slides
                                ref="myVueperSlides"
                                autoplay
                                :speed="18000"
                                :pause-on-hover="pauseOnHover"
                                @autoplay-pause="internalAutoPlaying = false"
                                @autoplay-resume="internalAutoPlaying = true">
                                <vueper-slide
                                    v-for="(slide, i) in slides"
                                    :key="slide.id"
                                    :title="slide.title"
                                    :content="slide.content"
                                    :image="slide.image"
                                />
                                <!--:style="'background-color: ' + colors[i % 4]"-->
                                <template #pause>
                                    <i class="icon pause_circle_outline"></i>
                                </template>
                            </vueper-slides>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>

    import AOS from 'aos'
    import 'aos/dist/aos.css'

    import { VueperSlides, VueperSlide } from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'

    export default {

        components: {
            SectionTitle: () => import('@/components/common/SectionTitle'),
            VueperSlides, 
            VueperSlide
        },

        // VueperSlides, VueperSlide
        // https://antoniandre.github.io/vueper-slides/?ref=madewithvuejs.com

        mounted() {
            AOS.init();
            //this.loadJsonData();
        },       

        data () {
            return {
                pauseOnHover: true,
                autoPlaying: true,
                internalAutoPlaying: true,
                slides: [
                    {
                    id: 'slide-1',
                    title: '1',
                    content: '',
                    image: 'images/photoshow/1.jpg'
                    },
                    {
                    id: 'slide-2',
                    title: '1',
                    content: '',
                    image: 'images/photoshow/2.jpg'
                    },                    
                    {
                    id: 'slide-3',
                    title: '1',
                    content: '',
                    image: 'images/photoshow/3.jpg'
                    },                    {
                    id: 'slide-4',
                    title: '1',
                    content: '',
                    image: 'images/photoshow/4.jpg'
                    },
                ]
            }
        },

        methods: {
            async loadJsonData() {
                try {
                    const response = await fetch("/data/songsdata.json"); 
                    const jsonData = await response.json();

                    console.log('jsonData')
                    console.log(jsonData)

                    this.columns = Object.keys(jsonData[0]).map((header) => ({
                        label: header,
                        field: header
                    }));

                    this.rows = jsonData;
                } catch (error) {
                    console.error("Error loading JSON:", error);
                }
            }
        },
    
    }
    
</script>